import React from "react";
import LeftQuote from "./images/blue-quote-left.svg";
import RightQuote from "./images/blue-quote-right.svg";
import PropTypes from "prop-types";

const IconBlueQuotes = ({ type = "left", ...props }) => {

    const iconMap = {
        left: LeftQuote,
        right: RightQuote
    };

    return (
        <img src={iconMap[type]} alt={"quotes"} {...props} />
    );
};

IconBlueQuotes.propTypes = {
    type: PropTypes.string
};

export default IconBlueQuotes;
